import React from 'react'
import { M_InputTextField, M_DrawerTableTextField, M_CheckBox, M_MessageBoard, M_Button } from 'src/components/M_Components'
import { WarningAmberOutlined } from '@mui/icons-material'

export default function Container({ optionsServiceContainer, container, setContainer, createStructure, t, setOpenModalGenerator, openModalGenerator, transportResources, setTransportResources }) {

    const sizeContainer = [
        { Name: 'Width', NormalizedName: 'Width', type: 'string', IsDisabled: false, IsRequired: true, IsHiddenList: false },
        { Name: 'Height', NormalizedName: 'Height', type: 'string', IsDisabled: false, IsRequired: true, IsHiddenList: false },
        { Name: 'Length', NormalizedName: 'Length', type: 'string', IsDisabled: false, IsRequired: true, IsHiddenList: false }
    ]

    return (
        <div className='cardOrderService'>
            <div className='divTitleCard'>
                <div className='divAlignTitleStatus'>
                    <div className='iconTitleCard'>
                        <img src="/icons/svgsDaNet/box.svg"
                            style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                            alt="Container"
                        />
                    </div>
                    <div className='labelTitleCard'>
                        {t("Container")}
                    </div>
                </div>
            </div>
            <div className='divGridContainer'>
                {optionsServiceContainer.filter((elem) => elem.IsHiddenList !== true).map((elem2, key2) => (
                    <div key={key2} className={elem2.GroupByInfo === 'ContainerSize' ? elem2.Name === 'Length' ? 'span-two-columns' : 'no-span' : ''}>
                        {elem2.IsForeignKey && elem2.Name !== 'Capacity' && (
                            <M_DrawerTableTextField
                                key={key2}
                                tableLabel={elem2.NormalizedName}
                                label={elem2.NormalizedName}
                                required={elem2.IsRequired}
                                entity={elem2.ForeignTableName}
                                value={container[elem2.ForeignTableToPassId] ?
                                    {
                                        [elem2.ForeignTableToPassId]: container[elem2.ForeignTableToPassId],
                                        [elem2.ForeignKeyName]: container[elem2.Name]
                                    } : null}
                                filterField={elem2.ForeignKeyName}
                                labelFields={[elem2.ForeignKeyName]}
                                onSubmitValue={obj => {
                                    let updatedContainer = { ...container }
                                    if (obj) {
                                        updatedContainer[elem2.Name] = obj[elem2.ForeignKeyName]
                                        updatedContainer[elem2.ForeignTableToPassId] = obj[elem2.ForeignTableToPassId]
                                        updatedContainer.TemperatureControl = obj.TemperatureControl
                                        updatedContainer.SpecialDimensions = obj.SpecialDimensions
                                        updatedContainer.TareWeigth = obj.TareWeigth //Tara
                                        updatedContainer.PayLoad = obj.PayLoad //Payload
                                    } else {
                                        updatedContainer[elem2.Name] = null
                                        updatedContainer[elem2.ForeignTableToPassId] = null
                                        updatedContainer.TemperatureControl = null
                                        updatedContainer.SpecialDimensions = null
                                        updatedContainer.TareWeigth = null
                                        updatedContainer.PayLoad = null
                                    }
                                    setContainer(updatedContainer)
                                    const hasGenerator =
                                        transportResources?.["Has Generator"] ??
                                        transportResources?.HasGenerator ??
                                        transportResources?.Generator

                                    const hasSpecialLicense =
                                        transportResources?.["Special License"] ??
                                        transportResources?.SpecialLicense

                                    if (updatedContainer.TemperatureControl !== true && hasGenerator) {
                                        setTransportResources(prevState => ({
                                            ...prevState,
                                            ["Has Generator"]: false,
                                            HasGenerator: false,
                                            Generator: false
                                        }))
                                    }

                                    if ((hasGenerator === false || hasGenerator === undefined) && updatedContainer.TemperatureControl === true) {
                                        setOpenModalGenerator(true)
                                    }

                                    if ((hasSpecialLicense === false || hasSpecialLicense === undefined) && updatedContainer.SpecialDimensions === true) {
                                        setTransportResources(prevState => ({
                                            ...prevState,
                                            ["Special License"]: true,
                                            SpecialLicense: true
                                        }))
                                    }

                                    if (updatedContainer.SpecialDimensions === null || updatedContainer.SpecialDimensions === undefined) {
                                        setTransportResources(prevState => ({
                                            ...prevState,
                                            ["Special License"]: false,
                                            SpecialLicense: false
                                        }))
                                    }
                                }}
                                disabled={container.Capacity ? false : true}
                                valueField={elem2.ForeignTableToPassId}
                                FILTER={`containerCapacityId eq ${container.CapacityId}`}
                            />
                        )}
                        {elem2.Type === 'string' && !elem2.IsForeignKey && (
                            <M_InputTextField
                                key={key2}
                                type={"text"}
                                label={elem2.NormalizedName}
                                required={elem2.IsRequired}
                                disabled={elem2.disable}
                                onChange={(e) => {
                                    let value = e.target.value
                                    if (elem2.Name === 'ContainerNumber') {
                                        if (value.length === 6 && !value.includes('/')) {
                                            value = value.slice(0, 6) + '/' + value.slice(6)
                                        }
                                    }
                                    createStructure(value, elem2.Name, "Container")
                                }}
                                value={container[elem2.Name] || ""}
                                maxNumbers={elem2.Name === 'Acronym' ? 4 : elem2.Name === 'ContainerNumber' ? 8 : null}
                            />
                        )}
                        {elem2.Type === 'boolean' && (
                            <div className='divCheckboxFormQuotes'>
                                <M_CheckBox
                                    key={key2}
                                    label={elem2.NormalizedName}
                                    onChange={(e) => createStructure(e.target.checked, elem2.Name, "Container")}
                                    checked={container[elem2.Name] || false}
                                    required={elem2.IsRequired}
                                />
                            </div>
                        )}
                        {elem2.Type === "datetime" && (
                            <M_InputTextField
                                key={key2}
                                type={"datetime-local"}
                                label={elem2.NormalizedName}
                                required={elem2.IsRequired}
                                disabled={elem2.disable}
                                onChange={(e) => createStructure(e.target.value, elem2.Name, "Container")}
                                value={container[elem2.Name] || ""}
                            />
                        )}
                        {elem2.Type === 'int32' && elem2.Name !== 'Capacity' && (
                            <M_InputTextField
                                key={key2}
                                type={"number"}
                                label={elem2.NormalizedName}
                                required={elem2.IsRequired}
                                disabled={elem2.Name === "Temperature" ? !container.TemperatureControl : elem2.Name === 'LoadWeight' ? true : false}
                                onChange={(e) => createStructure(e.target.value, elem2.Name, "Container")}
                                value={elem2.Name !== 'LoadWeight' ? container[elem2.Name] || "" : (container.TareWeigth + container.NetWeight) || 0}
                                iconEnd={elem2.Name === 'Temperature' ? "ºC" : ""}
                                iconStart={elem2.Name === 'LoadWeight' && (container.TareWeigth + container.NetWeight || 0) > container.PayLoad ? <WarningAmberOutlined style={{ color: 'red' }} /> : null
                                }
                            />
                        )}
                        {elem2.Type === 'int32' && elem2.Name === 'Capacity' && (
                            <M_DrawerTableTextField
                                key={key2}
                                tableLabel={elem2.NormalizedName}
                                label={elem2.NormalizedName}
                                required={elem2.IsRequired}
                                entity={elem2.ForeignTableName}
                                value={{
                                    [elem2.Name]: container[elem2.Name] || ""
                                }}
                                filterField={elem2.Name}
                                labelFields={[elem2.Name]}
                                onSubmitValue={obj => {
                                    let updatedContainer = { ...container }
                                    if (obj) {
                                        updatedContainer[elem2.Name] = obj[elem2.ForeignKeyName]
                                        updatedContainer[elem2.ForeignTableToPassId] = obj[elem2.ForeignTableToPassId]
                                    } else {
                                        updatedContainer[elem2.Name] = null
                                        updatedContainer[elem2.ForeignTableToPassId] = null
                                    }
                                    setContainer(updatedContainer)
                                }}
                                disabled={elem2.disable}
                                valueField={elem2.Name}
                            />
                        )}
                        {elem2.GroupByInfo === "ContainerSize" && elem2.Name === 'Length' && (
                            <div className='divPrincipalAlignInputsSize'>
                                {sizeContainer.map((size, index) => (
                                    <div key={index} className='divAlignInputsSize'>
                                        <M_InputTextField
                                            key={index}
                                            type={"number"}
                                            label={t(size.NormalizedName)}
                                            required={!container.SpecialDimensions}
                                            disabled={!container.SpecialDimensions}
                                            onChange={(e) => createStructure(e.target.value, size.Name, "Container")}
                                            value={container[size.Name] || ""}
                                        />
                                        <div className='divGlobalXImg'>
                                            {index !== sizeContainer.length - 1 && (
                                                <img src="/icons/svgsDaNet/x.svg" alt="" className='imgXSize' />
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
            {container.Type !== undefined && container.Type !== "" && container.Type !== null ?
                <div className='divInfoContainerOrderServiceinTabs'>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src="/icons/svgsDaNet/info.svg"
                            style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)', width: '25px', marginRight: '10px' }}
                            alt="Info"
                        />
                        <b>{t("ContainerDetails")} </b>
                    </div>
                    <div className='displayInfoContainerOrderServiceinTabs'>
                        <span><b>{t("Capacity")}:</b> {container.Capacity}</span>
                        <span><b>{t("ContainerType")}:</b> {container.Type}</span>
                        <span><b>{t("Tara")}:</b> {container.TareWeigth} Kg</span>
                        <span><b>{t("Payload")}:</b> {container.PayLoad} Kg</span>
                    </div>
                </div>
                : ""}

            {/* alerta de gerador no contentor */}
            <M_MessageBoard
                open={openModalGenerator}
                onClose={() => setOpenModalGenerator(false)}
                title={
                    <div className='divTitleMessageBoardInformation'>
                        <img src="/icons/svgsDaNet/alert-triangle.svg"
                            style={{ filter: 'invert(87%) sepia(14%) saturate(7477%) hue-rotate(7deg) brightness(98%) contrast(102%)', width: '35px', marginRight: '10px' }}
                            alt="OrderService"
                        />
                        {t("AddGenerator")}
                    </div>
                }
                body={
                    <div>
                        <div>
                            {t("AdvanceWithGenerator")}
                        </div>
                        <br />
                        <div>
                            <b>{t("Note")}:</b> {t("AdvanceWithoutGenerator")}
                        </div>
                    </div>
                }
                footer={
                    <div className='divFooterAlertsOrderService'>
                        <M_Button backgroundColor={'var(--color-red)'} label={t("WhitoutGenerator")} labelColor={'var(--color-white)'} onClick={() => setOpenModalGenerator(false)} />
                        <M_Button
                            backgroundColor={'var(--color-green)'}
                            label={t("ActivateGenerator")}
                            labelColor={'var(--color-white)'}
                            onClick={() => {
                                setTransportResources(prevState => ({
                                    ...prevState,
                                    ["Has Generator"]: true,
                                    HasGenerator: true,
                                    Generator: true
                                }))
                                setOpenModalGenerator(false)
                            }}
                        />
                    </div>
                }
            />

        </div>
    )
}
